import { useEffect, useState } from "react";
import { IState } from "../redux/redux";
import StoreX, { store } from "../redux/oldStore";
import { ServerResponse } from "../utils/Server";
import { toast } from "react-toastify";
import { EasyImage, SlickImage } from "./Tools/EasyImage";
import Modal from "./Modal/Modal";


interface IProps {
    state:IState;
    reloadSignal?: number;
}

interface IPhotoInfo {
    Name: string,
    DisplayName: string;
    PrintedDescription:string,
    PhotoCredit:string,
    Dimension:string,
    FileSizeBytes:number,
    SourceId:string,
    CreatedAtUtc:string,
}

const PhotoGallery = (props:IProps) =>{
    const [data, setData] = useState<IPhotoInfo[]>([]);
    const [selectedPhoto, setSelectedPhoto] = useState<IPhotoInfo>();
    const selectedPhotoUrl = selectedPhoto
        ? StoreX.BuildUrl(`../File/Client/${selectedPhoto.SourceId}`)
        : "";
    
    useEffect(()=>{
        init();
    }, []);

    useEffect(()=>{
        if(props.reloadSignal) init();
    }, [props.reloadSignal]);

    const init = () =>{
        store.server.getApi<ServerResponse<IPhotoInfo[]>>(`../PhotoBooth/Data`)
        .then(x=>{
            if(x.Success){
                let xData = x.Value;
                setData(xData);
            } else {
                toast.error(x.Message);
            }
        });
    };


    return <>
        <div className="image-gallery photo-gallery">
            {data.map((x,i)=>{
                let url = StoreX.BuildUrlWithFair(`../File/Client/${x.SourceId}`);
                return <div className="image-of-gallery click" key={i}>
                    <div onClick={() => setSelectedPhoto(x)}>
                        <SlickImage image={{path:url, comments:x.Name}} />
                    </div>
                    <div className="photo-gallery-meta">
                        {!!x.DisplayName && <strong>{x.DisplayName}</strong>}
                        {!!x.PrintedDescription && <p>{x.PrintedDescription}</p>}
                        {!!x.PhotoCredit && <small>Photo credit: {x.PhotoCredit}</small>}
                    </div>
                </div>
            })}
        </div>
        {selectedPhoto && (
            <Modal
                setModalOpen={() => setSelectedPhoto(undefined)}
                title={selectedPhoto.DisplayName || selectedPhoto.Name || "Photo"}
                className="file-input-preview-sizer"
            >
                <div className="file-preview">
                    <img className="gallery-image-x file-preview-grow" src={selectedPhotoUrl} alt={selectedPhoto.Name} />
                     <div className="photo-gallery-meta">
                        {!!selectedPhoto.DisplayName && <strong>{selectedPhoto.DisplayName}</strong>}
                        {!!selectedPhoto.PrintedDescription && <p>{selectedPhoto.PrintedDescription}</p>}
                        {!!selectedPhoto.PhotoCredit && <small>Photo credit: {selectedPhoto.PhotoCredit}</small>}
                    </div>
                    <div className="gallery-control-panel">
                        <a href={selectedPhotoUrl} target="_blank" rel="noreferrer" title="view file">
                            Open
                        </a>
                    </div>
                </div>
            </Modal>
        )}
    </>
};

export default PhotoGallery;